/** The device's position, once (Sprint 103.0). Kept in memory only (ADR-0120 Rule 3). */

import type { Place } from '../model/sky.ts';

export function locate(timeoutMs = 15_000): Promise<Place | undefined> {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(undefined);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) =>
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracyMetres: position.coords.accuracy,
          source: 'device'
        }),
      () => resolve(undefined),
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 60_000 }
    );
  });
}
